import { getInfo, login, logout, requestPasswordChange, resetPassword, register } from '@/util/Api/auth.js';
import { getToken, removeToken, setToken } from '@/util/auth.js';

const state = {
    id: null,
    token: getToken(),
    name: '',
    avatar: '',
    authUser: null,
    //   introduction: '',
    //   roles: [],
    //   permissions: [],
};

const mutations = {
    SET_ID: (state, id) => {
        state.id = id;
    },
    SET_AUTH_USER: (state, user) => {
        state.authUser = user;
    },
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar;
    },
    //   SET_INTRODUCTION: (state, introduction) => {
    //     state.introduction = introduction;
    //   },
    //   SET_ROLES: (state, roles) => {
    //     state.roles = roles;
    //   },
    //   SET_PERMISSIONS: (state, permissions) => {
    //     state.permissions = permissions;
    //   },
};

const actions = {
    // user login
    login({ commit }, userInfo) {
        const { email, password } = userInfo;
        return new Promise((resolve, reject) => {
            login({ email: email, password: password, isFromDashboard: true })
                .then(response => {
                    commit('SET_AUTH_USER', response.data);
                    commit('SET_ID', response.data.user.id);
                    commit('SET_TOKEN', response.data.token);
                    setToken(response.data.token);
                    resolve(response.data);
                }).catch(error => {
                    reject(error);
                });
        });
    },

    // user register
    register({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            register(userInfo)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // get user info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            getInfo(state.token)
                .then(response => {
                    const { data } = response;

                    if (!data) {
                        reject('Verification failed, please Login again.');
                    }

                    const { name, avatar, id } = data;

                    //   commit('SET_ROLES', roles);
                    //   commit('SET_PERMISSIONS', permissions);
                    commit('SET_NAME', name);
                    commit('SET_AVATAR', avatar);
                    commit('SET_ID', id);
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // user logout
    logout({ commit, state }) {
        return new Promise((resolve, reject) => {
            logout(state.token)
                .then(() => {
                    commit('SET_TOKEN', '');
                    localStorage.removeItem("id");
                    localStorage.removeItem("user");
                    removeToken();
                    resolve();
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // user request password change
    requestPasswordChange({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            requestPasswordChange(userInfo)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // user reset password
    resetPassword({ commit }, userInfo) {
        return new Promise((resolve, reject) => {
            resetPassword(userInfo)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '');
            removeToken();
            resolve();
        });
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};